import { MonthYearRecurrence } from "@libs/constants/month-year-recurrence.enum.ts";

export enum RecurrenceFormLabels {
  patient = "Patient",
  endSchedule = "End schedule",
  occurrence = "Occurrence",
  startTime = "Start time",
  endTime = "End time",
  recurEvery = "Recur every",
  on = "On",
  purpose = "Purpose",
  startSchedule = "Start schedule"
}
export interface RecurrenceFormValues {
  bookedBy: string;
  orgUnitId: string;
  providerId: string;
  startDate: Date;
  endScheduleType: string;
  startTime: string;
  endTime: string;
  purpose?: string;
  reasonForNotWorking?: string;
  interval: number;
  frequency: number;
  count?: number;
  until?: Date;
  dayRecur?: number[];
  monthRecur?: number[];
  monthDayRecur?: number[];
  weekPosition?: number;
  monthYearRecurrence?: MonthYearRecurrence;
}
